import type { ReactNode } from "react";
import { Maximize2 } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ChartTitleRowProps {
  title: string;
  /** Range/grouping toggles etc. — right-aligned, before the expand button. */
  controls?: ReactNode;
  onExpand: () => void;
  /** Localised "Expand chart". */
  expandLabel: string;
}

/**
 * One title row for every dashboard chart so the convention never drifts:
 * title left (medium weight, not bold), controls right-aligned, a 12px gap,
 * and the expand button always last at the same size everywhere.
 */
export function ChartTitleRow({ title, controls, onExpand, expandLabel }: ChartTitleRowProps) {
  return (
    <div className="flex items-center justify-between gap-3">
      <h3 className="truncate text-sm font-medium text-neutral-700">{title}</h3>
      <div className="flex flex-shrink-0 items-center gap-3">
        {controls}
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          aria-label={expandLabel}
          onClick={onExpand}
        >
          <Maximize2 className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
